import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IFerryCapacityRestrictionAttributes extends IModelAttributes {
	ferryId: string;
	capacityRestrictionId: string;

	ferry: Models.FerryEntity | Models.IFerryEntityAttributes;
	capacityRestriction: Models.CapacityRestrictionEntity | Models.ICapacityRestrictionEntityAttributes;
}

@entity('FerryCapacityRestriction')
export default class FerryCapacityRestriction extends Model implements IFerryCapacityRestrictionAttributes {
	@observable
	@attribute()
	public ferryId: string;

	@observable
	@attribute()
	public capacityRestrictionId: string;

	@observable
	@attribute({ isReference: true })
	public ferry: Models.FerryEntity;

	@observable
	@attribute({ isReference: true })
	public capacityRestriction: Models.CapacityRestrictionEntity;

	constructor(attributes?: Partial<IFerryCapacityRestrictionAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.ferryId) {
				this.ferryId = attributes.ferryId;
			}
			if (attributes.capacityRestrictionId) {
				this.capacityRestrictionId = attributes.capacityRestrictionId;
			}

			if (attributes.ferry) {
				if (attributes.ferry instanceof Models.FerryEntity) {
					this.ferry = attributes.ferry;
					this.ferryId = attributes.ferry.id;
				} else {
					this.ferry = new Models.FerryEntity(attributes.ferry);
					this.ferryId = this.ferry.id;
				}
			} else if (attributes.ferryId !== undefined) {
				this.ferryId = attributes.ferryId;
			}

			if (attributes.capacityRestriction) {
				if (attributes.capacityRestriction instanceof Models.CapacityRestrictionEntity) {
					this.capacityRestriction = attributes.capacityRestriction;
					this.capacityRestrictionId = attributes.capacityRestriction.id;
				} else {
					this.capacityRestriction = new Models.CapacityRestrictionEntity(attributes.capacityRestriction);
					this.capacityRestrictionId = this.capacityRestriction.id;
				}
			} else if (attributes.capacityRestrictionId !== undefined) {
				this.capacityRestrictionId = attributes.capacityRestrictionId;
			}
		}
	}
}
